"use client";

import Helper from "@/utils/helper";
import React, { useEffect, useState } from "react";
import { getSettingV2 } from "@/lib/api/shop/setting";

import Local from "@/common/constants/local";
import SettingApi from "@/common/constants/setting";
import { EventJson, EventPopupJson } from "@/types/Event.type";

import LinkElement from "@/components/LinkElement";
import PopupV2 from "@/components/PopupV2";
import useTimeServer from "@/lib/hooks/useTimeServer";
import { TimeServerJson } from "@/types/Setting.type";
import Image from "@/components/ui/Image";
import { cn } from "@/utils/utils";
import ImageV2 from "@/components/ui/ImageV2";
import ImageConstant from "@/common/constants/image";
import NextImage from "next/image";
import imageDefault from "public/assets/images/imageDefault.png";

export default function EventPopup() {
	//global

	const { data: timeServer } = useTimeServer(10, "eventpopup");

	//variables
	const POPUP_EVENT_KEY = Local.storage.popup_event;

	//states
	const [event, setEvent] = useState<EventJson | undefined>(undefined);
	const [open, setOpen] = useState<boolean>(false);

	const [imageUrl, setImageUrl] = useState("");

	//functions

	//local
	const getLocal = async () => {
		try {
			if (!Helper.isServer()) {
				const storage = localStorage.getItem(POPUP_EVENT_KEY);

				if (storage) {
					const eventLocal = JSON.parse(storage) as EventPopupJson;
					// dispatch(setEventPopup(JSON.parse(storage) );

					return eventLocal;
				} else {
					return initialLocal();
				}
			}
		} catch (error) {}
	};

	const initialLocal = (data?: EventPopupJson) => {
		try {
			const popupInitial: EventPopupJson = {
				key: data?.key || "web_popup",
				count: data?.count || 0,
				timestamp: data?.timestamp || 0,
			};
			localStorage.setItem(POPUP_EVENT_KEY, JSON.stringify(popupInitial));
			return popupInitial;
		} catch (error) {
			console.error("Error initializing local storage:", error);
		}
	};

	//fetch data
	const getEvents = async (): Promise<EventJson[] | undefined> => {
		try {
			const { data } = await getSettingV2(SettingApi.KEY.k_setting_web_popup);
			return Array.isArray(data.value)
				? (data.value as EventJson[])
				: undefined;
		} catch (error) {
			return undefined;
		}
	};

	const fetchEvents = async (timeSV: TimeServerJson) => {
		const data = await getEvents();

		if (data && data.length > 0) {
			const currentActive = data[0];
			// if (currentActive && currentActive.key.length > 0) {
			const server = timeSV.time_server * 1000;
			const from = currentActive.from_time;
			const to = currentActive.to_time;

			if (Helper.checkTimeServer(server, from, to)) {
				const local = await getLocal();
				if (!local || local.key !== currentActive.key) {
					initialLocal({
						count: 1,
						key: currentActive.key,
						timestamp: server / 1000,
					});

					setEvent(currentActive);
					setOpen(true);
					return;
				}

				if (
					local.count < currentActive.time_limit &&
					currentActive.time_delay < server / 1000 - local.timestamp
				) {
					initialLocal({
						count: local.count + 1,
						key: local.key,
						timestamp: server / 1000,
					});

					setEvent(currentActive);
					setOpen(true);
				}
			}
			// }
		}
	};

	useEffect(() => {
		timeServer && fetchEvents(timeServer.data);
	}, [timeServer]);

	useEffect(() => {
		if (event) {
			const setResponsiveImage = () => {
				if (window.innerWidth < 768) {
					setImageUrl(event?.image?.mobile?.url ?? "");
				} else {
					setImageUrl(event?.image?.desktop?.url ?? "");
				}
			};

			// Set image URL on initial render
			setResponsiveImage();

			// Set event listener to update image URL on resize
			window.addEventListener("resize", setResponsiveImage);

			// Cleanup event listener on component unmount
			return () => {
				window.removeEventListener("resize", setResponsiveImage);
			};
		}
	}, [JSON.stringify(event)]);

	return (
		<>
			<PopupV2
				open={open}
				classNameContent="w-fit h-fit md:max-w-fit bg-transparent shadow-none p-0 min-w-[300px] min-h-[300px]"
				onOpenChange={() => {
					setOpen(false);
				}}>
				<LinkElement
					href={event?.link || ""}
					prefetch={false}
					className={cn("drop-shadow-md relative inline-block ")}>
					<NextImage
						className="relative min-w-[90vw] md:min-w-0"
						width={414}
						height={414}
						alt={event?.alt || "popup_image"}
						src={imageUrl.length > 0 ? imageUrl : imageDefault}
						layout="responsive"
						objectFit="contain"
						blurDataURL={ImageConstant.BlurDataURL}
						placeholder="blur"
						loading="lazy"></NextImage>

					{/* <div
						style={
							{
								"--bgdesk": `url(${event?.image?.desktop?.url || ""})`,
								"--bgmobile": `url(${event?.image?.mobile?.url || ""})`,
							} as React.CSSProperties
						}
						className={`w-full max-w-[97vw] h-auto md:w-[50vw] md:max-w-[900px] rounded-[8px]  bg-center bg-no-repeat bg-cover event-popup`}></div> */}
				</LinkElement>
			</PopupV2>
		</>
	);
}
